import PropTypes from "prop-types";
import { Component } from "react";

export default class STSComponent extends Component {
  constructor(props) {
    super(props);

    // if (new.target.name === "InputField") {
    //   console.log("Constructing: " + new.target.name + " Props: ", props);
    // }

    if (props) {
      this.enableHistoryUndo = props.enableHistoryUndo;
    }

    // this.enableHistoryUndo = true;

    // this.state = {
    //   undoData: this.props.undoTrackData,
    // };
  }

  get isHistoryUndoEnabled() {
    return this.enableHistoryUndo;
  }

  shouldComponentUpdate(nextProps, nextState) {
    //console.log("Update? " + this.constructor.name);
    return true;
  }

  componentDidMount() {
    //console.log("undo :", undoTrackData);
  }

  updateData = (location, valueType, valueID, fieldValue, arrayIndex) => {
    if (this.props.updateData) {
      this.props.updateData(
        location,
        valueType,
        valueID,
        fieldValue,
        this.isHistoryUndoEnabled,
        arrayIndex
      );
    } else {
      console.error(
        `STS Component ${this.constructor.name} in ${location.page}:${location.field}
        did not receive updateData Prop and it was called!`
      );
    }
  };

  static propTypes = {
    enableHistoryUndo: PropTypes.bool,
    // undoTrackData: PropTypes.object,
    updateData: PropTypes.func,
  };
}



// WEBPACK FOOTER //
// ./src/components/STSComponent/STSComponent.js